import { isBefore } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import shortid from "shortid";
import {
  Autocomplete,
  Button,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  DatePicker,
  FormControlLabel,
  FullscreenDialog,
  Grid,
  IconButton,
  InputAdornment,
  LoadingAi,
  Paper,
  PermissionDialog,
  Tab,
  TabPanel,
  Tabs,
  TextField,
  Tooltip,
} from "../../../components";
import { useCacheContext } from "../../../contexts/cache.context";
import { useImportContext } from "../../../contexts/import.context";
import { InputErros, PermisoesHelper, value } from "../../../helpers";
import { boletosHelper } from "../../../helpers/boletos.helper";
import { AddLayout } from "../../../layouts";
import {
  BancosCaixasService,
  BoletoService,
  ColaboradorService,
  ContasReceberService,
  EmpresaService,
  EnderecoService,
  EnderecosEstoqueService,
  MeioPagamentoService,
  NfEntradaService,
  NfSaidaService,
  OperacaoFiscalService,
  OrigemMercadoriaService,
  PessoaService,
  PlugBoletoService,
  SessionService,
  SituacaoTributariaIpiService,
  TabelaVendaService,
  history,
  notification,
} from "../../../services";
import {
  cacheApi,
  formatCnpj,
  formatDate,
  formatPrice,
  montarFiltroPessoa,
  responseErros,
  userLogs,
  verificarBaixaAutomatica,
  voltar,
} from "../../../utils";
import AddPessoas from "../../pessoas/addPessoa/addPessoa.view";
import {
  BoletoApiEntity,
  BoletoEntity,
  NfSaida,
  NfSaidaCancelamento,
  NfSaidaEnderecoCliente,
} from "../entities";
import {
  calcularLimiteCreditoUltrapassado,
  calcularPrecoProduto,
  compararPagamentosTotalNfSaida,
  dataEmissaoBloqueada,
  encontrarEnderecoPadrao,
  formatTotalItemAcrescimo,
  limparCampoTotalizador,
  mapearEndereco,
  mapearEnderecos,
  modeloDocumentoFiscal,
  tabProps,
  totalItensLista,
  validarTabelaTodosProdutosMeioPagamento,
  validarTabelaVendaCliente,
  validarTabelaVendaMeioPagamento,
} from "./add-nf-saida";
import {
  ButtonMenu,
  CancelamentoDialog,
  CartaCorrecaoDialog,
  CopiarNfSaidaDialog,
  EnderecoClienteEstabelecimentoDialog,
  ErrosDfeDialog,
  IdentificarClienteDialog,
  NfSaidaDadosClientes,
  NfSaidaInformacoes,
  NfSaidaItens,
  NfSaidaPagamentos,
  NfSaidaTransporte,
  NfSaidaTributos,
  ResumoTotal,
  SelecionarInscricaoEstadualDialog,
} from "./components";
import EmissaoBoletoDialog from "./components/dialogComponents/emissao-boleto-dialog.component";
import HistorioClienteDialog from "./components/dialogComponents/historico-cliente-dialog.component";
import { limitesVenda, URI_IMPORTACAO } from "./constantes";
import { enderecoValidator, nfSaidaValidator } from "./middlewares";

const contasReceberService = new ContasReceberService();
const sessionService = new SessionService();
const nfSaidaService = new NfSaidaService();
const operacaoFiscalService = new OperacaoFiscalService();
const pessoaService = new PessoaService();
const colaboradorService = new ColaboradorService();
const enderecoService = new EnderecoService();
const meioPagamentoService = new MeioPagamentoService();
const origemMercadoriaService = new OrigemMercadoriaService();
const situacaoIpiService = new SituacaoTributariaIpiService();
const tabelaVendaService = new TabelaVendaService();
const empresaService = new EmpresaService();
const nfEntradaService = new NfEntradaService();
const bancoCaixaService = new BancosCaixasService();
const enderecosEstoqueService = new EnderecosEstoqueService();
const apiBoletoService = new PlugBoletoService();
const boletoService = new BoletoService();

let nfSaidaEntity = {
  dataEmissao: formatDate.toSend(new Date()),
  dataSaida: formatDate.toSend(new Date()),
  modalidadeFrete: "mfSemFrete",
  freteCompoeNota: true,
};

const MENSAGEMLOADINGEMITIR = [
  "Transmitindo Documento",
  "Análisando retorno da Sefaz ",
  "Finalizando processo de emissão",
];

const AddNfSaida = ({ match }) => {
  const ultimaParteCaminho = window.location.pathname.split("/").pop();
  const documentoImportado =
    ultimaParteCaminho.includes("importar") ||
    URI_IMPORTACAO.includes(ultimaParteCaminho);
  const transferencia = ultimaParteCaminho === "transferencia";
  const id = !documentoImportado && !transferencia && match.params.id;
  const { initialCollapses } = useImportContext();
  const { cacheDto, setCacheDto } = useCacheContext();
  const [nfSaida, setNfSaida] = useState(nfSaidaEntity);
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("nf-saida-visualizar");
  const vendedorObrigatorio = permissoesHelper.temPermisao(
    "nf-saida-vendedor-obrigatorio",
  );
  const inputCliente = useRef();
  const dadosEmpresa = sessionService.getEmpresaAndUsuario();
  const [loading, setLoading] = useState(true);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [loadingAI, setLoadingAI] = useState(false);
  const [mensagemLoadingAI, setMensagemLoadingAI] = useState(null);
  const [userLog, setUserLog] = useState({});
  const [isCadastroPessoaDialogOpen, setIsCadastroPessoaDialogOpen] =
    useState(false);
  const [identificarClienteDialogOpen, setIdentificarClienteDialogOpen] =
    useState(false);
  const [meiosPagamentoCliente, setMeiosPagamentoCliente] = useState(null);
  const [clienteSemCadastro, setClienteSemCadastro] = useState(false);
  const [errosDfeDialogOpen, setErrosDfeDialogOpen] = useState(false);
  const [errosDfe, setErrosDfe] = useState(null);
  const [abaValue, setAbaValue] = useState(0);
  const [operacaoFiscalList, setOperacaoFiscalList] = useState([]);
  const [operacaoFiscal, setOperacaoFiscal] = useState({});
  const [clienteList, setClienteList] = useState([]);
  const [vendedorList, setVendedorList] = useState([]);
  const [transportadoraList, setTransportadoraList] = useState([]);
  const [enderecosEstoqueList, setEnderecosEstoqueList] = useState([]);
  const [cidadeId, setCidadeId] = useState(null);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const permissaoLimiteCreditoUltrapassado =
    permissoesHelper.getPermisoesModulo(
      "nf-saida-vender-limite-credito-ultrapassado",
    );
  const permissaoClienteInadimplente = permissoesHelper.getPermisoesModulo(
    "nf-saida-vender-cliente-inadimplente",
  );
  const [dialogLimiteCreditoUltrapassado, setDialogLimiteCreditoUltrapassado] =
    useState({ open: false });
  const [transportadoraSelecionada, setTransportadoraSelecionada] =
    useState(null);
  const [tabelas, setTabelas] = useState({
    cliente: null,
    grupoPessoa: null,
  });
  const [tabelasTodosProdutos, setTabelasTodosProdutos] = useState([]);
  const [endereco, setEndereco] = useState({
    padrao: false,
  });
  const [enderecoCliente, setEnderecoCliente] = useState(null);
  const [enderecoClienteDataGrid, setEnderecoClienteDataGrid] = useState([]);
  const [enderecoAleterado, setEnderecoAleterado] = useState(null);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [meioPagamentoSelecionado, setMeioPagamentoSelecionado] =
    useState(null);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(null);
  const [listaProdutosSimilares, setListaProdutosSimilares] = useState([]);
  const [configuracoes, setConfiguracoes] = useState({});
  const [nfSaidaListReferencia, setNfSaidaListReferencia] = useState([]);
  const [nfSaidaProdutos, setNfSaidaProdutos] = useState([]);
  const [item, setItem] = useState(null);
  const [nfSaidaPagamentos, setNfSaidaPagamentos] = useState([]);
  const [gerarPagamentos, setGerarPagamentos] = useState({});
  const [condicaoPagParcelaList, setCondicaoPagParcelaList] = useState([]);
  const [intermediadorSelecionado, setIntermediadorSelecionado] =
    useState(null);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [origensMercadoriasList, setOrigensMercadoriasList] = useState([]);
  const [listaEstados, setListaEstados] = useState([]);
  const [situacaoIpiList, setSituacaoIpiList] = useState([]);
  // const [dadosImpressao, setDadosImpressao] = useState(null);
  const [listaNotasCredito, setListaNotasCredito] = useState([]);
  const [openCancelamentoDialog, setOpenCancelamentoDialog] = useState(false);
  const [openNotasCreditoDialog, setOpenNotasCreditoDialog] = useState(false);
  const [
    openEnderecoClienteForaEstabelecimentoDialog,
    setOpenEnderecoClienteForaEstabelecimentoDialog,
  ] = useState(false);
  const [meioPagamentoCredito, setMeioPagamentoCredito] = useState({});
  const [notasCredito, setNotasCredito] = useState([]);
  const [openCartaCorrecaoDialog, setOpenCartaCorrecaoDialog] = useState(false);
  const [openCopiarNfSaidaDialog, setOpenCopiarNfSaidaDialog] = useState(false);
  const [dialogInscricaoEstadual, setDialogInscricaoEstadual] = useState(false);
  const [inscricoesEstaduais, setInscricoesEstaduais] = useState({});
  const [inscricaoSelecionada, setInscricaoSelecionada] = useState({
    inscricao: "",
    endereco: null,
  });
  const [tiposTotalizadoresColumnView, setTiposTotalizadoresColumnView] =
    useState(false);
  const [colaboradorVendedor, setColaboradorVendedor] = useState(null);
  const [unidadeList, setUnidadeList] = useState([]);
  const [gruposTributacaoList, setGruposTributacaoList] = useState([]);
  const [csoSimplesList, setCsoSimplesList] = useState([]);
  const [situacaoIbsList, setSituacaoIbsList] = useState([]);
  const [classificacaoIbsList, setClassificacaoIbsList] = useState([]);
  const [nfsSaida, setNfsSaida] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [acrescimoPagamento, setAcrescimoPagamento] = useState(null);
  const [produto, setProduto] = useState(null);
  const [enquadramentoLegalList, setEnquadramentoLegalList] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [documentoTransferencia, setDocumentoTransferencia] =
    useState(transferencia);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
  const [openDialogEnvioWhatsapp, setOpenDialogEnvioWhatsapp] = useState(false);
  const [openHistoricoClienteDialog, setOpenHistoricoClienteDialog] =
    useState(false);
  const [boletos, setBoletos] = useState([]);
  const [documentosReferenciados, setDocumentosReferenciados] = useState([]);
  const [openEmissaoBoletoDialog, setOpenEmissaoBoletoDialog] = useState(false);
  const [envioMensagemBoleto, setEnvioMensagemBoleto] = useState(false);
  const [listaIdImpressao, setListaIdImpressao] = useState([]);
  const nfSaidaValidatorService = nfSaidaValidator({
    operacaoFiscal,
    documentoTransferencia,
  });

  const tiposPessoa = [
    {
      tipoId: 1,
      setLista: (dados) => setClienteList(dados),
    },
    {
      tipoId: 2,
      setLista: (dados) => setClienteList(dados),
    },
    {
      tipoId: 3,
      setLista: (dados) => setTransportadoraList(dados),
    },
    {
      tipoId: 4,
      setLista: (dados) => setVendedorList(dados),
    },
  ];

  const buscarConfiguracao = async () => {
    if (dadosEmpresa.empresa.configuracoes) {
      const data = dadosEmpresa.empresa.configuracoes;
      setConfiguracoes(data);
      nfSaidaEntity.setConfiguracoes(data);
      setNfSaida({ ...nfSaidaEntity });
      if (data?.operacaoFiscalVendasPadraoId) {
        await buscaDadosOperacoesFiscais(data.operacaoFiscalVendasPadraoId);
      } else {
        await buscaDadosOperacoesFiscais();
      }
    } else {
      await buscaDadosOperacoesFiscais();
    }
  };

  async function buscaDadosIniciais() {
    if ((!id && !documentoImportado) || documentoTransferencia) {
      nfSaidaEntity = new NfSaida({
        dataEmissao: formatDate.toSend(new Date()),
        dataSaida: formatDate.toSend(new Date()),
        modalidadeFrete: "mfSemFrete",
        freteCompoeNota: true,
      });
      await buscarPessoaVendedor();
    } else {
      await buscarNfSaida();
    }
    await buscarConfiguracao();
    if (documentoTransferencia) {
      await buscarEmpresasAcesso();
    }
    buscarTabelasVendaTodosProdutos();
    buscarMeiosPagamento();
    buscarVendedores();
    buscaSituacaoIpi();
    buscarOrigensMercadoria();
    buscaEstados();
    buscarEnderecosEstoque();
  }

  async function buscarNfSaidaReferencia(filtros) {
    setLoadingAutoComplete(true);
    const result = await nfSaidaService.getAllFiltroAvancado({
      ...filtros,
      disabledInclude: true,
      status: "ENVIADA",
      attributes: [
        "id",
        "numeroDocumento",
        "serieDocumento",
        "modeloDocumento",
        "chaveAcesso",
        "dataEmissao",
      ],
    });
    if (!result.isAxiosError) {
      setLoadingAutoComplete(false);
      return result.data.rows;
    } else {
      responseErros(result);
      setLoadingAutoComplete(false);
    }
  }

  const buscarPessoaVendedor = async (filtros) => {
    const filtro = {
      ...filtros,
      nonPaginated: true,
      vendedor: true,
    };
    const result = await colaboradorService.getAll(filtro);
    if (!result.isAxiosError) {
      const colaboradorVendedorUsuario = result.data.find(
        (colaborador) => colaborador.usuarioId === dadosEmpresa.usuario.id,
      );
      if (colaboradorVendedorUsuario) {
        nfSaidaEntity.setColaboradorVendedorUsuario(
          colaboradorVendedorUsuario.pessoa.id,
          colaboradorVendedorUsuario.bancoCaixaId,
          permissoesHelper.temPermisao("utilizar-caixa-colaborador"),
        );
        nfSaidaEntity.setVendedorObrigatorioPermissao(vendedorObrigatorio);
        setColaboradorVendedor(colaboradorVendedorUsuario);
        setNfSaida(nfSaidaEntity);
      }
    } else {
      responseErros(result);
    }
  };

  async function buscaDadosOperacoesFiscais(idOperacaoFiscalVenda) {
    let filtrosOperacoesFiscais = {
      ativado: true,
      nonPaginated: true,
      tipoOperacao: "SAIDA",
      finalidade: [
        "NAO_SE_APLICA",
        "NFE_NORMAL",
        "NFE_COMPLEMENTAR",
        "NFE_AJUSTE",
      ],
      restritiva: true,
      porIntervalo: [],
    };
    if (nfSaidaEntity?.chaveAcessoReferencia) {
      filtrosOperacoesFiscais.finalidade = nfSaidaEntity?.finalidade;
    }
    if (nfSaidaEntity?.documentoDevolucaoCliente) {
      filtrosOperacoesFiscais.tipoOperacao = "ENTRADA";
      filtrosOperacoesFiscais.finalidade = "DEVOLUCAO";
    }
    if (nfSaidaEntity?.documentoDevolucaoFornecedor) {
      filtrosOperacoesFiscais.finalidade = "DEVOLUCAO";
    }
    if (nfSaidaEntity?.operacaoEntrada) {
      filtrosOperacoesFiscais.tipoOperacao = "ENTRADA";
      delete filtrosOperacoesFiscais.finalidade;
    }
    await buscarOperacoesFiscais(
      filtrosOperacoesFiscais,
      idOperacaoFiscalVenda,
    );
  }

  const buscarOrigensMercadoria = () => {
    const cacheBody = {
      dto: { cacheDto, setCacheDto },
      apiFunction: origemMercadoriaService.getAll(),
    };
    cacheApi("origemmercadoria", cacheBody).then((res) => {
      if (!res.isAxiosError) {
        setOrigensMercadoriasList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscaSituacaoIpi = () => {
    const cacheBody = {
      dto: { cacheDto, setCacheDto },
      apiFunction: situacaoIpiService.getAll(),
    };
    cacheApi("situacaoipi", cacheBody).then((result) => {
      if (!result.isAxiosError) {
        setSituacaoIpiList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarEnderecosEstoque = () => {
    const filter = {
      nonPaginated: true,
    };
    enderecosEstoqueService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setEnderecosEstoqueList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const validarProdutosTabelaVenda = (tabelasVenda = null) => {
    const tabelasVendaProduto = tabelasVenda ?? tabelas;
    const tabelaTodosProdutos = validarTabelaTodosProdutosMeioPagamento(
      tabelasTodosProdutos,
      meioPagamentoSelecionado?.id,
    );

    if (nfSaidaProdutos.length > 0) {
      const produtosAtualizados = nfSaidaProdutos.map((pedidoProduto) => {
        let resultItem = {
          ...pedidoProduto,
          descontoPorcentagem: 0,
          desconto: 0,
          despesas: 0,
        };
        if (
          validarTabelaVendaCliente(
            tabelasVendaProduto?.cliente,
            resultItem.produtoId,
          )
        ) {
          resultItem = calcularPrecoProduto(
            resultItem,
            tabelasVendaProduto?.cliente,
          );
        } else if (tabelasVendaProduto?.grupoPessoa) {
          resultItem = calcularPrecoProduto(
            resultItem,
            tabelasVendaProduto?.grupoPessoa,
          );
        } else if (
          validarTabelaVendaMeioPagamento(
            pedidoProduto?.tabelasVenda,
            meioPagamentoSelecionado?.id,
          )
        ) {
          resultItem = calcularPrecoProduto(
            resultItem,
            resultItem?.tabelasVenda[0] || {},
            "meioPagamento",
          );
        } else if (tabelaTodosProdutos) {
          resultItem = calcularPrecoProduto(resultItem, tabelaTodosProdutos);
        } else {
          const { valorUnitario, subtotal, totalItem } =
            formatTotalItemAcrescimo(resultItem, acrescimoPagamento);
          resultItem.valor = valorUnitario;
          resultItem.subtotal = subtotal;
          resultItem.totalItem = totalItem;
          resultItem.desconto = pedidoProduto.desconto;
          resultItem.descontoPorcentagem = pedidoProduto.descontoPorcentagem;
          resultItem.despesas = pedidoProduto.despesas;
        }
        return resultItem;
      });
      setNfSaidaProdutos(produtosAtualizados);
      nfSaidaEntity.setChangeItens(id, produtosAtualizados);
      setNfSaida(nfSaidaEntity);
    }
  };

  useEffect(() => {
    validarProdutosTabelaVenda();
  }, [meioPagamentoSelecionado]);

  useEffect(() => {
    buscaDadosIniciais().then(setLoading(false));
  }, [id]);

  const buscarNfSaida = async () => {
    if (id) {
      const response = await nfSaidaService.getById(id);
      if (!response.isAxiosError) {
        if (!response.data) {
          initialCollapses();
          voltar();
          return;
        }
        nfSaidaEntity = new NfSaida(response.data, id);
        if (nfSaidaEntity?.empresaDestinoId) {
          setDocumentoTransferencia(true);
          await buscarEmpresasAcesso();
        }
        /*         if (
          nfSaidaEntity?.status === "ENVIADA" ||
          nfSaidaEntity?.status === "CANCELADA" ||
          nfSaidaEntity?.status === "CONTINGENCIA"
        ) {
          await buscarNfSaidaDadosXml(response.data);
        } */
      } else {
        responseErros(response);
      }
    } else {
      nfSaidaEntity = window?.nfSaidaEntity;
    }
    await inserirDadosNfSaida();
    await inserirDadosPessoas();
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(nfSaidaEntity);
    setUserLog(logs);
  }

  async function inserirDadosNfSaida() {
    await buscaDadosOperacoesFiscais();
    const operacaoFiscal = await getOperacaoFiscal(
      nfSaidaEntity?.operacaoFiscalId,
    );
    if (operacaoFiscal) {
      nfSaidaEntity.setOperacaoFiscal(operacaoFiscal);
      setOperacaoFiscal(operacaoFiscal);
    }
    nfSaidaEntity.setChangeItens(
      id,
      nfSaidaEntity?.nfSaidaItens,
      nfSaidaEntity,
    );
    nfSaidaEntity.nfSaidaItens.forEach((item) => {
      item.setTotal(item, nfSaida);
    });
    nfSaidaEntity.setChangePagamentos(nfSaidaEntity?.nfSaidaPagamentos);
    setNfSaida(nfSaidaEntity);
    const nfSaidaItens = nfSaidaEntity?.nfSaidaItens?.length
      ? nfSaidaEntity?.nfSaidaItens.map((produto) => ({
          ...produto,
          id: shortid.generate(),
        }))
      : [];
    const nfSaidaPagamentos = nfSaidaEntity?.nfSaidaPagamentos?.length
      ? nfSaidaEntity?.nfSaidaPagamentos.map((pagamento) => ({
          ...pagamento,
          id: shortid.generate(),
        }))
      : [];
    if (nfSaidaEntity.intermediadorRazaoSocial) {
      const intermediador = {
        nomeRazaoSocial: nfSaidaEntity.intermediadorRazaoSocial,
        cnpjCpf: nfSaidaEntity.intermediadorCnpj,
      };
      setIntermediadorSelecionado(intermediador);
    }
    setNfSaidaProdutos(nfSaidaItens);
    setNfSaidaPagamentos(nfSaidaPagamentos);
    setEnderecoAleterado(nfSaidaEntity.nfSaidaEnderecoCliente);
    setDocumentosReferenciados(nfSaidaEntity.nfSaidaReferencias || []);
    if (nfSaidaEntity.nfSaidaReferencias?.length) {
      await buscarNfSaidasReferenciadas(
        nfSaidaEntity.nfSaidaReferencias.map(
          (referencia) => referencia.nfSaidaReferenciaId,
        ),
      );
    }
  }

  async function buscarNfSaidasReferenciadas(nfSaidaIds) {
    const result = await nfSaidaService.getAllFiltroAvancado({
      id: nfSaidaIds,
      disabledInclude: true,
      attributes: ["id", "chaveAcesso", "serieDocumento", "numeroDocumento"],
    });
    if (!result.isAxiosError) {
      setNfSaidaListReferencia(result.data.rows);
    } else {
      responseErros(result);
    }
  }

  async function inserirDadosPessoas() {
    const pessoaIds = [];
    if (nfSaidaEntity?.clienteId) {
      pessoaIds.push(nfSaidaEntity?.clienteId);
    } else if (nfSaidaEntity?.clienteNome || nfSaidaEntity?.clienteCnpjCpf) {
      setClienteSelecionado({
        nomeRazaoSocial: nfSaidaEntity?.clienteNome ?? null,
        cnpjCpf: nfSaidaEntity?.clienteCnpjCpf ?? null,
      });
      setClienteSemCadastro(true);
    }
    if (nfSaidaEntity?.transportadoraId) {
      pessoaIds.push(nfSaidaEntity?.transportadoraId);
    } else if (
      nfSaidaEntity?.transportadoraNome ||
      nfSaidaEntity?.transportadoraCnpjCpf
    ) {
      setTransportadoraSelecionada({
        nomeRazaoSocial: nfSaidaEntity?.transportadoraNome ?? null,
        cnpjCpf: nfSaidaEntity?.transportadoraCnpjCpf ?? null,
      });
    }
    if (pessoaIds.length) {
      const pessoas = await buscarPessoas({ id: pessoaIds });
      if (pessoas.rows?.length) {
        if (nfSaidaEntity?.clienteId) {
          const cliente = pessoas.rows.find(
            (pessoa) => pessoa.id == nfSaidaEntity?.clienteId,
          );
          setClienteSelecionado(cliente);
          adicionarEnderecosCliente(cliente.enderecos);
        }
        if (nfSaidaEntity?.transportadoraId) {
          const transportadora = pessoas.rows.find(
            (pessoa) => pessoa.id == nfSaidaEntity?.transportadoraId,
          );
          setTransportadoraSelecionada(transportadora);
        }
      }
    }
  }

  async function buscarPessoas(filtros) {
    const res = await pessoaService.getAll(filtros);
    if (!res.isAxiosError) {
      return res.data;
    } else {
      responseErros(res);
    }
    return [];
  }

  const buscarPessoasPorTipo = async (filtros, tiposPessoaId) => {
    const filtro = {
      ...filtros,
      tiposPessoaId,
      nonPaginated: true,
      ativado: true,
    };
    const tipoPessoaTemp = tiposPessoa.find(
      ({ tipoId }) => tipoId === tiposPessoaId,
    );
    const pessoas = await buscarPessoas(filtro);
    setLoadingAutoComplete(false);
    if (pessoas?.length) {
      tipoPessoaTemp?.setLista(pessoas);
    }
  };

  const buscarVendedores = () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 4,
      vendedor: true,
      ativado: true,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setVendedorList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarOperacoesFiscais = async (filtros, idOperacaoFiscalVenda) => {
    const result = await operacaoFiscalService.getAllFiltroAvancado(filtros);
    if (!result.isAxiosError) {
      setOperacaoFiscalList(result.data);
      if (
        idOperacaoFiscalVenda &&
        result.data?.length &&
        !id &&
        !nfSaidaEntity?.operacaoFiscalId
      ) {
        const operacaoPadrao = result.data.find(
          (operacao) => operacao.id === idOperacaoFiscalVenda,
        );
        if (operacaoPadrao) {
          setOperacaoFiscal(operacaoPadrao);
          nfSaidaEntity.setOperacaoFiscal(operacaoPadrao);
          setNfSaida(nfSaidaEntity);
          if (
            nfSaidaEntity.obrigatoriedadeMeioPagamento &&
            operacaoPadrao?.movimentacaoFinanceira
          ) {
            setAbaValue(1);
          }
        }
      }
    } else {
      responseErros(result);
    }
  };

  const getOperacaoFiscal = async (id) => {
    if (!id) return;
    return operacaoFiscalService.getById(id).then((result) => {
      if (!result.isAxiosError) {
        return result.data;
      } else {
        responseErros(result);
        return null;
      }
    });
  };

  const buscarMeiosPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    if (
      nfSaidaEntity?.documentoDevolucaoCliente ||
      nfSaidaEntity?.documentoDevolucaoFornecedor
    ) {
      filtro.nfePagamento = "fpCreditoEmLoja";
    }
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamentoList(result.data);
        setMeioPagamentoCredito(
          result.data.find((meio) => meio.nfePagamento == "fpCreditoEmLoja"),
        );
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDadosClientes = async (clienteId) => {
    if (!clienteId) return setClienteSelecionado(null);
    pessoaService.getById(clienteId).then((result) => {
      if (!result.isAxiosError) {
        buscarDocumentosCliente(clienteId);
        setClienteSelecionado((prevState) => ({
          ...prevState,
          ...result.data,
        }));
        if (result.data.enderecos?.length)
          adicionarEnderecosCliente(result.data.enderecos);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDocumentosCliente = async (clienteId) => {
    setLoadingHistorico(true);
    nfSaidaService
      .getAll({ clienteId })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data.rows.length) {
            setNfsSaida(result.data.rows);
            setTotalItems(result.data.count);
          } else {
            setNfsSaida([]);
            setTotalItems(0);
          }
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoadingHistorico(false));
  };

  const buscarDadosTransportadora = async (transportadoraId) => {
    if (transportadoraId) {
      pessoaService.getById(transportadoraId).then((result) => {
        if (!result.isAxiosError) {
          setTransportadoraSelecionada(result.data);
        } else {
          responseErros(result);
        }
      });
    } else {
      setTransportadoraSelecionada(null);
    }
  };

  const buscaEstados = () => {
    const cacheBody = {
      timeMinutes: 60,
      apiFunction: enderecoService.getEstados(),
      dto: { cacheDto, setCacheDto },
    };
    cacheApi(`${enderecoService.urlBase}/estados`, cacheBody).then((res) => {
      if (!res.isAxiosError) {
        setListaEstados(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarTabelasVendaTodosProdutos = async () => {
    const filtros = {
      ativado: true,
      nonPaginated: true,
      restritiva: true,
      tabelaRegente: true,
      tipoTabela: "TODOS_PRODUTOS",
    };
    const response = await tabelaVendaService.getAll(filtros);
    if (!response.isAxiosError) {
      setTabelasTodosProdutos(response.data);
    } else {
      responseErros(response);
    }
  };

  const buscarTodasTabelasVenda = async (pessoaId, intGrupoPessoaId) => {
    setLoading(true);
    try {
      const filtros = {
        ativado: true,
        nonPaginated: true,
        restritiva: true,
        tabelaRegente: true,
        tipoTabela: "POR_PRODUTO",
      };
      const response = await tabelaVendaService.getAll(filtros);
      if (response.isAxiosError) {
        responseErros(response);
        return;
      }
      const tabelasProcessadas = response.data.reduce(
        (acc, tabela) => {
          const pessoa = tabela?.pessoaIds.find(
            (tabelaPessoa) => tabelaPessoa.intPessoaId == pessoaId,
          );
          if (pessoa) {
            acc.cliente = tabela;
          } else if (
            intGrupoPessoaId &&
            tabela.intGrupoPessoaId === intGrupoPessoaId
          ) {
            acc.grupoPessoa = tabela;
          }
          return acc;
        },
        { cliente: null, grupoPessoa: null, todosProdutos: null },
      );

      validarProdutosTabelaVenda(tabelasProcessadas);
      setTabelas(tabelasProcessadas);
    } catch (error) {
      console.error("Erro ao buscar tabelas:", error);
    } finally {
      setLoading(false);
    }
  };

  const buscarEmpresasAcesso = async () => {
    empresaService.getFiliaisMatriz().then((result) => {
      if (!result.isAxiosError) {
        setEmpresas(
          result.data.filter(
            (empresa) => empresa.cnpjCpf !== dadosEmpresa.empresa?.cnpjCpf,
          ),
        );
      } else {
        responseErros(result);
      }
    });
  };

  async function adicionarEnderecosCliente(enderecos) {
    const enderecoPadrao = encontrarEnderecoPadrao(enderecos);
    if (enderecoPadrao) {
      const enderecoCliente = mapearEndereco(enderecoPadrao);
      setEnderecoCliente(enderecoCliente);
      nfSaidaEntity.setEnderecoCliente(null, enderecoCliente);
    }
    const enderecosMapeados = mapearEnderecos(enderecos);
    setEnderecoClienteDataGrid(enderecosMapeados);
  }

  const handleInputChange = (e) => {
    const name = e.target.name;
    nfSaidaEntity.setHandleChangeInput(name, e.target.value);
    if (name === "freteCompoeNota" && nfSaidaEntity.nfSaidaItens?.length) {
      nfSaidaEntity.setTotalVenda();
    }
    setNfSaida((prevState) => ({ ...prevState, ...nfSaidaEntity }));
  };

  const onSearchChangePessoas = (event, inputRef, tiposPessoaId) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = montarFiltroPessoa(event.target?.value, tiposPessoaId);
      setLoadingAutoComplete(true);
      buscarPessoasPorTipo(filtros, tiposPessoaId);
    }
  };

  const handleDateChange = (fieldName, date) => {
    if (!date) {
      date = "Invalid Date";
    }
    nfSaidaEntity.setHandleChangeDate(fieldName, date);
    setNfSaida(nfSaidaEntity);
  };

  const handleCloseCadastroCliente = () => {
    buscarPessoasPorTipo();
    setNfSaida(nfSaidaEntity);
    setIsCadastroPessoaDialogOpen(false);
  };

  const handleDialogErrorDfe = (responseData, status, idNfSaida) => {
    let message = null;
    if (responseData?.response?.retornoNf?.protNFe) {
      message = responseData.response.retornoNf.protNFe.xMotivo;
      if (!responseData.response?.analiseAi) {
        responseData.response.analiseAi = {
          rejeicao: {
            codigo: responseData.response.retornoNf.protNFe.cStat,
          },
        };
      }
    } else message = responseData?.response?.retornoNf?.message;
    const analiseAi = responseData?.response?.analiseAi || null;
    setErrosDfe({ mensagem: message, status, idNfSaida, analiseAi });
    setErrosDfeDialogOpen(true);
  };

  const verificarStatus = (status) => {
    switch (status) {
      case "PENDENTE":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#EA9D2B" }}></i>
        );
      case "ENVIADA":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#4FBB53" }}></i>
        );
      case "CONTINGENCIA":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#BFBFBF" }}></i>
        );
      case "CANCELADA":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#DC3545" }}></i>
        );
      case "INUTILIZADA":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#e012a6" }}></i>
        );
      case "DENEGADA":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#70309F" }}></i>
        );
      case "EM PROCESSAMENTO":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#A0522D" }}></i>
        );
      case "FATURADA":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#004780" }}></i>
        );
    }
  };

  const salvarEndereco = async () => {
    const body = {
      ...endereco,
      cidadeId: cidadeId,
      pessoaId: nfSaida?.clienteId,
    };
    enderecoValidator
      .validate(body, { abortEarly: false })
      .then(async () => {
        setLoading(true);
        const res = await pessoaService.cadastrarEndereco(
          nfSaida?.clienteId,
          body,
        );
        if (!res.isAxiosError) {
          notification.cadastroSucesso();
          setEnderecoClienteDataGrid([
            ...enderecoClienteDataGrid,
            { ...body, id: shortid.generate() },
          ]);
        } else {
          responseErros(res);
        }
        setLoading(false);
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const inicialFormulario = () => {
    setNfSaida({ freteCompoeNota: true });
    setNfSaidaProdutos([]);
    setNfSaidaPagamentos([]);
  };

  const removerDadosCliente = () => {
    setListaNotasCredito([]);
    setEnderecoClienteDataGrid([]);
    setEnderecoCliente(null);
    setEnderecoAleterado(null);
    nfSaidaEntity.setEnderecoCliente();
    setNfSaida(nfSaidaEntity);
  };

  const verificarInscricaoEstadual = (cliente) => {
    if (!cliente) return;
    const inscricoes = {
      inscricaoEstadual: cliente?.inscricaoEstadual,
      inscricaoEstadual2: cliente?.inscricaoEstadual2,
      inscricaoEstadualRural: cliente?.inscricaoEstadualRural,
      inscricaoEstadualRural2: cliente?.inscricaoEstadualRural2,
    };
    const inscricoesUnicas = Object.keys(inscricoes).filter(
      (key) => inscricoes[key],
    );
    if (inscricoesUnicas.length > 1) {
      setInscricoesEstaduais({
        ...inscricoesUnicas.reduce((acc, key) => {
          if (key.includes("2")) {
            acc["SECUNDARIA"] = inscricoes[key];
          } else {
            acc["PRIMARIA"] = inscricoes[key];
          }
          return acc;
        }, {}),
      });
      setInscricaoSelecionada(inscricoes[inscricoesUnicas[0]]);
      setDialogInscricaoEstadual(true);
    } else {
      setDialogInscricaoEstadual(false);
      setInscricoesEstaduais([]);
      setInscricaoSelecionada(inscricoes[inscricoesUnicas[0]] || "");
    }
  };

  const onChangeAutocomplete = (name, value) => {
    nfSaidaEntity.setHandleChangeAutoComplete(name, value, listaEstados);
    setNfSaida((prevState) => ({ ...prevState, ...nfSaidaEntity }));
  };

  const onClickCancelarNfSaida = async () => {
    setOpenCancelamentoDialog(true);
  };

  const onClickValidarNfSaida = async () => {
    if (id) {
      setLoading(true);
      const response = await nfSaidaService.validarNotaFiscal(id);
      setLoading(false);
      if (!response.isAxiosError) {
        notification.sucessoGenericos("Nota validada com sucesso");
      } else {
        const res = response.response;
        if (res.status === 500 && res.data?.message) {
          handleDialogErrorDfe(res.data, 500);
          return;
        }
        if (res.status === 400 && res.data?.message) {
          handleDialogErrorDfe(res.data, 400);
          return;
        }
        notification.alertaGenericos(response.mensagem);
      }
    }
  };

  const onChangeAutocompleteCliente = (newValue) => {
    setInputErro([]);
    setClienteSemCadastro(false);
    removerDadosCliente();
    const clienteRepetido = newValue?.id === clienteSelecionado?.id;
    if (!id && !clienteRepetido) {
      setNfSaidaPagamentos([]);
      nfSaidaEntity.setChangePagamentos([]);
      setGerarPagamentos((prevState) => ({
        ...prevState,
        valorTitulo: nfSaida?.totalPedido,
      }));
    }
    onChangeAutocomplete("clienteId", newValue);
    setClienteSelecionado(newValue);
    buscarDadosClientes(newValue?.id);
    if (operacaoFiscal?.modeloDocumento === "55") {
      verificarInscricaoEstadual(newValue);
    }
    if (newValue?.clientes?.length) {
      buscarTodasTabelasVenda(
        newValue?.id,
        newValue?.clientes?.[0]?.grupoPessoaId,
      );
      buscarLimiteCreditoInadimplencia(
        newValue?.id,
        newValue?.clientes[0]?.limiteCompra,
      );
      buscarNotasCredito(newValue?.id);
      filterMeiosPagamentoCliente(newValue.clientes[0]);
      if (!id) {
        const sugestaoVendedorId = newValue.clientes[0].sugestaoVendedorId;
        const sugestaoVendedor = vendedorList.filter(
          ({ id }) => id === sugestaoVendedorId,
        );
        if (sugestaoVendedorId && sugestaoVendedor.length > 0) {
          onChangeAutocomplete("vendedorId", sugestaoVendedor[0]);
        }
      }
    } else {
      const tabelaVazia = {
        cliente: null,
        grupoPessoa: null,
      };
      setTabelas(tabelaVazia);
      validarProdutosTabelaVenda(tabelaVazia);
      setMeiosPagamentoCliente(null);
    }
  };

  const confirmarInscricaoEstadual = () => {
    nfSaidaEntity.setInscricaoEstadual(inscricaoSelecionada.inscricao);
    const endereco = new NfSaidaEnderecoCliente(inscricaoSelecionada.endereco);
    setEnderecoCliente(endereco);
    nfSaidaEntity.setEnderecoCliente(null, endereco);
    setNfSaida((prevState) => ({ ...prevState, ...nfSaidaEntity }));
    setDialogInscricaoEstadual(false);
  };

  const onChangeAutocompleteEmpresaDestino = (newValue) => {
    setInputErro([]);
    removerDadosCliente();
    const clienteRepetido = newValue?.id === clienteSelecionado?.id;
    if (!id && !clienteRepetido) {
      setNfSaidaPagamentos([]);
      nfSaidaEntity.setChangePagamentos([]);
      setGerarPagamentos((prevState) => ({
        ...prevState,
        valorTitulo: nfSaida?.totalPedido,
      }));
    }
    onChangeAutocomplete("empresaDestinoId", newValue);
    setEmpresaSelecionada(newValue);
    nfSaidaEntity.setEnderecoClienteEmpresa(newValue);
    setNfSaida(nfSaidaEntity);
  };

  const filterMeiosPagamentoCliente = (cliente) => {
    if (cliente.meiosPagamento?.length) {
      const meioPagamentoIds = cliente.meiosPagamento.map(
        ({ meioPagamentoId }) => meioPagamentoId,
      );
      const filterMeioPagamento = meioPagamentoList.filter((item) =>
        meioPagamentoIds.includes(item.id),
      );
      setMeiosPagamentoCliente(filterMeioPagamento);
      const meioPagamentoValido = meioPagamentoIds.find(
        (id) => id === gerarPagamentos?.meioPagamentoId,
      );
      if (gerarPagamentos?.meioPagamentoId && !meioPagamentoValido) {
        setGerarPagamentos((prevState) => ({
          ...prevState,
          meioPagamentoId: null,
          condicaoPagamentoId: null,
        }));
        setCondicaoPagParcelaList([]);
      }
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  const onChangeAutocompleteOperacaoFiscal = (newValue) => {
    setInputErro([]);
    nfSaidaEntity.setOperacaoFiscal(newValue);
    setOperacaoFiscal(newValue);
    setNfSaida(nfSaidaEntity);
    if (
      newValue?.movimentacaoFinanceira &&
      !nfSaidaProdutos?.length &&
      configuracoes?.obrigatoriedadeMeioPagamento
    ) {
      setAbaValue(1);
    } else {
      setAbaValue(0);
    }
  };

  const handleChangeSwitch = (name, checked) => {
    if (
      (name === "descontoItem" ||
        name === "freteItem" ||
        name === "despesasItem") &&
      nfSaidaEntity.nfSaidaItens?.length
    ) {
      const nomeCampo = name.replace("Item", "");
      const listaItensTotalizador = limparCampoTotalizador(
        nomeCampo,
        nfSaidaEntity.nfSaidaItens,
      );
      nfSaidaEntity.setChangeItens(id, listaItensTotalizador);
      setNfSaidaProdutos([...nfSaidaEntity.nfSaidaItens]);
      setItem((prevState) => ({
        ...prevState,
        [nomeCampo]: 0,
      }));
    }
    nfSaidaEntity.setHandleChangeSwitch(name, checked);
    setNfSaida({ ...nfSaidaEntity });
  };

  const buscarNotasCredito = (pagadorId) => {
    const filtro = {
      pagadorId,
      tipo: "NOTA_CREDITO",
      status: ["ABERTO", "BAIXADO_PARCIAL"],
      restritiva: true,
    };
    contasReceberService.getAllFiltroAvancado(filtro).then((result) => {
      if (!result.isAxiosError) {
        setListaNotasCredito(result.data.rows);
      } else responseErros(result);
    });
  };

  const buscarLimiteCreditoInadimplencia = (pagadorId, limiteCredito = 0) => {
    contasReceberService
      .getLimiteCreditoInadimplencia(pagadorId, limiteCredito)
      .then((result) => {
        if (!result.isAxiosError) {
          setClienteSelecionado((prevState) => ({
            ...prevState,
            limiteCreditoDisponivel: result.data.limiteDisponivel,
            inadimplente: result.data.inadimplente,
          }));
        } else responseErros(result);
      });
  };

  async function alertaNotasCredito() {
    const totalNf =
      (nfSaida.totalVenda || 0) - (nfSaida.totalPagamentos || 0) > 0;
    if (
      listaNotasCredito.length > 0 &&
      !nfSaidaEntity?.documentoDevolucaoCliente &&
      !nfSaidaEntity?.documentoDevolucaoFornecedor &&
      totalNf
    ) {
      const confirmacaoAlerta = await notification.confirmacaoGenericos({
        title: "Cliente com crédito",
        text: `Deseja utilizar nesta compra?`,
        icon: "warning",
        confirmButtonText: "SIM",
        cancelButtonText: "NÃO",
        showCancelButton: true,
      });
      if (confirmacaoAlerta.isConfirmed) {
        setOpenNotasCreditoDialog(true);
      }
    }
  }

  const onClickCartaCorrecao = () => {
    setOpenCartaCorrecaoDialog(true);
  };

  const onClickOpenDialogCopiarNfSaida = () => {
    setOpenCopiarNfSaidaDialog(true);
  };

  async function confirmarEmissaoBoletos(boletos, dadosNfSaida) {
    const props = {
      title: "Pagamento via boleto",
      text: "Deseja emitir o pagamento via boleto?",
      icon: "success",
      confirmButtonText: "EMITIR",
      cancelButtonText: "FECHAR",
      showCancelButton: true,
    };
    const confirmacaoAlerta = await notification.confirmacaoGenericos(props);
    if (confirmacaoAlerta.isConfirmed) {
      const bancos = boletos.map(
        (item) => item.meioPagamentoSelecionado.bancoCaixaId,
      );
      const contas = await bancoCaixaService.getAll({ id: bancos });

      let emissaoDireta = true;
      const boletosTemp = boletos.map((item) => {
        const conta = contas.data.rows.find(
          (caixa) => caixa.id === item.meioPagamentoSelecionado.bancoCaixaId,
        );
        let convenioSelecionado = null;
        if (conta.convenios.length === 1) {
          convenioSelecionado = conta.convenios[0];
        } else {
          emissaoDireta = false;
        }
        return {
          ...item,
          id: shortid.generate(),
          conta,
          convenioSelecionado,
        };
      });
      setBoletos(boletosTemp);

      if (emissaoDireta) {
        await emitirBoletos(boletosTemp, dadosNfSaida);
      } else {
        setOpenEmissaoBoletoDialog(true);
      }
    } else {
      await emitirAposCadastro(dadosNfSaida);
    }
  }

  async function emitirBoletos(boletos, dadosNfSaida) {
    setLoading(true);

    const body = [],
      convenios = [],
      boletosTemp = [...boletos];
    for (let index = 0; index < boletosTemp.length; index++) {
      const boleto = boletosTemp[index];
      let nossoNumero = boleto.convenioSelecionado.nossoNumeroInicial,
        convenio = convenios.find(
          (c) => c.id === boleto.convenioSelecionado.id,
        );
      if (!convenio) {
        convenios.push({ id: boleto.convenioSelecionado.id, nossoNumero });
      } else {
        convenio.nossoNumero++;
        nossoNumero = convenio.nossoNumero;
      }
      boleto.nossoNumero = String(nossoNumero);
      boleto.registroInstantaneo =
        boleto.convenioSelecionado.registroInstantaneo;
      boleto.numeroConvenio = boleto.convenioSelecionado.numero;
      boleto.convenioId = boleto.convenioSelecionado.id;
      boleto.tituloDocumento = `${dadosNfSaida.serieDocumento}${
        dadosNfSaida.numeroDocumento
      }-${index + 1}`;
      body.push(new BoletoApiEntity(boleto, dadosNfSaida, nossoNumero));
    }

    const apiResponse = await apiBoletoService.incluirBoletosLote(
      body,
      dadosEmpresa.empresa?.cnpjCpf,
    );
    const boletosParaCadastro = [];
    let validacaoErro = false;
    if (apiResponse._dados?._sucesso?.length) {
      boletosParaCadastro.push(...apiResponse._dados._sucesso);
    }

    const bodyCadastro = boletosTemp.map((boleto) => {
      const boletoApi = boletosParaCadastro.find(
        (b) =>
          boleto.nossoNumero === b.TituloNossoNumero &&
          boleto.numeroConvenio === b.CedenteConvenioNumero,
      );
      let erros = null;
      if (!boletoApi) {
        validacaoErro = true;
        const erroApi = apiResponse._dados?._falha?.find(
          (f) =>
            boleto.nossoNumero === f._dados?.TituloNossoNumero &&
            boleto.numeroConvenio === f._dados?.CedenteConvenioNumero,
        )?._erro;
        erros = erroApi?.erros ? Object.values(erroApi.erros).join(";") : null;
      }
      return new BoletoEntity(boletoApi, boleto, dadosNfSaida.clienteId, erros);
    });

    const res = await boletoService.cadastrarLote(bodyCadastro);
    if (res.isAxiosError) {
      responseErros(res);
    }

    setOpenEmissaoBoletoDialog(false);
    setLoading(false);

    if (!validacaoErro && configuracoes?.enviarBoletoAposEmissao) {
      const props = {
        title: "Boleto emitido com sucesso",
        text: `#${dadosNfSaida.numeroDocumento}`,
        icon: "success",
        confirmButtonText: "IMPRIMIR",
        cancelButtonText: "EMAIL",
        showCancelButton: true,
        showCloseButton: true,
        closeButtonHtml:
          "<i class='ph-bold ph-x' style='font-size: 21px' aria-hidden='true'></i>",
        dangerMode: true,
      };
      if (dadosEmpresa.empresa?.whatsappSimples) {
        props.width = "min(38rem, calc(100vw - 2rem))";
        props.denyButtonText = "WHATSAPP";
        props.showDenyButton = true;
      }

      const confirmacaoAlerta = await notification.confirmacaoGenericos(props);
      const listaIds = bodyCadastro.map(
        ({ integradorImpressaoId }) => integradorImpressaoId,
      );

      if (confirmacaoAlerta?.isDenied) {
        setEnvioMensagemBoleto(true);
        setListaIdImpressao(listaIds);
        setOpenDialogEnvioWhatsapp(true);
        return;
      } else if (confirmacaoAlerta.isConfirmed) {
        setLoading(true);
        await boletosHelper.imprimirBoletosUnicoPdf(listaIds, dadosEmpresa);
      } else if (confirmacaoAlerta?.dismiss === "cancel") {
        setLoading(true);
        await boletosHelper.enviarEmailUnicoPdf(
          listaIds,
          `${dadosNfSaida.serieDocumento}/${dadosNfSaida.numeroDocumento}`,
          clienteSelecionado,
          dadosEmpresa,
        );
      }
    } else if (validacaoErro) {
      setLoading(true);
      notification.alertaGenericos(
        "Houve erro ao incluir boletos no sistema. Favor verificar status na aba de Boletos",
      );
    } else {
      setLoading(true);
      notification.sucessoGenericos("Boleto(s) emitido(s) com sucesso");
    }

    setTimeout(() => {
      setLoading(false);
      emitirAposCadastro(dadosNfSaida);
    }, 2000);
  }

  const validarInformacoesBoleto = () => {
    const meioPagamentoBoleto = nfSaidaEntity.nfSaidaPagamentos.some(
      (item) => item.meioPagamentoSelecionado?.gerarBoleto,
    );
    if (meioPagamentoBoleto && !nfSaidaEntity.nfSaidaEnderecoCliente?.cep) {
      notification.alertaGenericos(
        "É necessário adicionar um endereço para a emissão de boletos",
      );
      return false;
    }

    return true;
  };

  async function handleSubmit(indiceSelecionado) {
    setLoading(true);
    if (!validarInformacoesBoleto()) {
      setLoading(false);
      return;
    }
    nfSaidaEntity.setNfSaidaReferencias(documentosReferenciados);
    nfSaidaValidatorService
      .validate(nfSaidaEntity, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await nfSaidaService.atualizar(id, nfSaidaEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            initialCollapses();
            history.push("/faturamento/nf-saida");
          } else {
            responseErros(response);
          }
        } else {
          const response = await nfSaidaService.cadastrar(nfSaidaEntity);
          setLoading(false);
          if (!response.isAxiosError) {
            if (!documentoTransferencia) {
              notification.cadastroSucesso();
            }
            if (indiceSelecionado === 0) {
              const nf = {
                ...nfSaida,
                ...response.data,
                nfSaidaItens: response.data.nfSaidaItens,
              };
              nfSaidaEntity.setChangeItens(
                nf?.id,
                response.data.nfSaidaItens || nfSaidaEntity.nfSaidaItens,
                nf,
              );
              setNfSaida(nf);
              if (documentoTransferencia) {
                const retornoTransferencia = await transferirNfSaida(nf);
                if (!retornoTransferencia) {
                  inicialFormulario();
                  history.push("/faturamento/nf-saida");
                  return;
                }
              }
              const boletos = dadosEmpresa.empresa.moduloBoleto
                ? nf.nfSaidaPagamentos
                    .filter(
                      (item) => item.meioPagamentoSelecionado?.gerarBoleto,
                    )
                    .map((item) => {
                      return {
                        ...item,
                        nfSaidaId: response.data?.id,
                      };
                    })
                : [];
              if (boletos.length && operacaoFiscal.tipoOperacao === "SAIDA") {
                await confirmarEmissaoBoletos(boletos, nf);
              } else {
                await emitirAposCadastro(nf);
              }
            } else {
              inicialFormulario();
            }
          } else responseErros(response);
        }
        window.nfSaidaEntity = {
          dataEmissao: formatDate.toSend(new Date()),
          dataSaida: formatDate.toSend(new Date()),
          nfSaidaItens: [],
          nfSaidaPagamentos: [],
          documentoImportado: false,
        };
      })
      .catch(async (err) => {
        setLoading(false);
        if (err.inner[0].path == "nfSaidaItens") setAbaValue(0);
        if (err.inner[0].path == "nfSaidaPagamentos") {
          if (operacaoFiscal?.movimentacaoFinanceira) {
            await alertaNotasCredito();
          }
          setAbaValue(1);
        }
        inputErros.set(err);
      });
  }

  async function validarNfSaida(indiceSelecionado) {
    if (
      !id &&
      modeloDocumentoFiscal(operacaoFiscal) &&
      isBefore(
        new Date(nfSaidaEntity?.dataSaida),
        new Date(nfSaidaEntity?.dataEmissao),
      )
    ) {
      setLoading(false);
      setInputErro(["dataSaida"]);
      return notification.alertaGenericos(
        "A data de saída não pode ser anterior à data de emissão",
      );
    }
    if (
      operacaoFiscal?.modeloDocumento === "55" &&
      operacaoFiscal?.finalidade !== "DEVOLUCAO" &&
      !documentoTransferencia &&
      !nfSaidaEntity?.nfSaidaEnderecoCliente?.id &&
      operacaoFiscal?.presencaConsumidor === "pcPresencialForaEstabelecimento"
    ) {
      setLoading(false);
      return notification.alertaGenericos(
        "É necessario cadastro de endereço para salvar",
      );
    }
    if (
      !verificarBaixaAutomatica(
        nfSaidaEntity?.nfSaidaPagamentos,
        meioPagamentoList,
      ) &&
      !nfSaidaEntity.clienteId
    ) {
      setLoading(false);
      return notification.alertaGenericos(
        "É necessário informar cliente para vendas a prazo",
      );
    }
    const pagamentosTotalNfSaida =
      compararPagamentosTotalNfSaida(nfSaidaEntity);
    if (pagamentosTotalNfSaida && operacaoFiscal?.movimentacaoFinanceira) {
      setLoading(false);
      setAbaValue(1);
      return notification.alertaGenericos(
        "É necessário atualizar valor da(s) parcela(s)",
      );
    }
    const limiteUF = limitesVenda.find(
      ({ uf }) => nfSaidaEntity?.nfSaidaEnderecoCliente?.estado === uf,
    )?.limite;
    if (
      limiteUF &&
      Number(nfSaidaEntity?.totalVenda) > limiteUF &&
      !nfSaidaEntity?.clienteCnpjCpf &&
      !documentoTransferencia &&
      operacaoFiscal?.modeloDocumento !== "01"
    ) {
      setLoading(false);
      setIdentificarClienteDialogOpen(true);
      return notification.alertaGenericos(
        `Vendas de valor superior a ${formatPrice(
          limiteUF,
        )} devem identificar cliente.`,
      );
    }
    const creditoUltrapassado = calcularLimiteCreditoUltrapassado(
      nfSaidaEntity.nfSaidaPagamentos,
      clienteSelecionado?.limiteCreditoDisponivel,
    );
    const limiteValido = await validarConfiguracaoLimiteCredito(
      creditoUltrapassado,
      permissaoLimiteCreditoUltrapassado,
    );
    if (!limiteValido) return;
    const inadimplenciaValida = await validarConfiguracaoInadimplencia(
      clienteSelecionado?.inadimplente,
      permissaoClienteInadimplente,
    );
    if (!inadimplenciaValida) return;
    if (
      operacaoFiscal?.modeloDocumento === "55" &&
      operacaoFiscal?.presencaConsumidor ===
        "pcPresencialForaEstabelecimento" &&
      !nfSaidaEntity.nfSaidaEnderecoCliente &&
      !nfSaidaEntity?.codigoMunicipioConsumo
    ) {
      setLoading(false);
      setOpenEnderecoClienteForaEstabelecimentoDialog(true);
      return;
    }
    await handleSubmit(indiceSelecionado);
  }

  async function validarConfiguracaoLimiteCredito(
    creditoUltrapassado,
    permissaoLimiteCreditoUltrapassado,
  ) {
    if (
      creditoUltrapassado &&
      !permissaoLimiteCreditoUltrapassado?.habilitado
    ) {
      switch (configuracoes.limiteCredito) {
        case "AVISAR":
          notification.alertaGenericos(
            "Cliente com limite de crédito ultrapassado",
          );
          break;
        case "BLOQUEAR": {
          const permissaoCredito = await mostrarDialogPermissao(
            permissaoLimiteCreditoUltrapassado?.nome,
            permissaoLimiteCreditoUltrapassado?.descricao,
          );
          if (!permissaoCredito) {
            notification.alertaGenericos(
              "Cliente com limite de crédito ultrapassado",
            );
            return false;
          }
          break;
        }
      }
    }
    return true;
  }

  async function validarConfiguracaoInadimplencia(
    clienteInadimplente,
    permissaoClienteInadimplente,
  ) {
    if (clienteInadimplente && !permissaoClienteInadimplente?.habilitado) {
      switch (configuracoes.inadimplencia) {
        case "AVISAR":
          notification.alertaGenericos("Cliente inadimplente");
          break;
        case "BLOQUEAR": {
          const permissaoInadimplencia = await mostrarDialogPermissao(
            permissaoClienteInadimplente?.nome,
            permissaoClienteInadimplente?.descricao,
          );
          if (!permissaoInadimplencia) {
            notification.alertaGenericos("Cliente inadimplente");
            return false;
          }
          break;
        }
      }
    }
    return true;
  }

  function mostrarDialogPermissao(permissionName, descricao) {
    if (!permissionName)
      return notification.alertaGenericos("permissão não encontrada");
    return new Promise((resolve) => {
      setDialogLimiteCreditoUltrapassado({
        open: true,
        permissao: permissionName,
        descricaoPermissao: descricao,
        onValidate: (permission) => {
          setDialogLimiteCreditoUltrapassado((prev) => ({
            ...prev,
            open: false,
          }));
          resolve(permission);
        },
        onClose: () => {
          setDialogLimiteCreditoUltrapassado((prev) => ({
            ...prev,
            open: false,
          }));
          resolve(false);
        },
      });
    });
  }

  const emitirAposCadastro = async (data) => {
    if (data.modeloDocumento === "01") {
      return await imprimeModeloZero(data);
    }
    const props = {
      title: "Documento cadastrado com sucesso",
      text: `#${data.numeroDocumento}`,
      icon: "success",
      confirmButtonText: "EMITIR",
      cancelButtonText: "FECHAR",
      showCancelButton: true,
    };
    const confirmacaoAlerta = await notification.confirmacaoGenericos(props);
    if (confirmacaoAlerta.isConfirmed) {
      let setLoadingCondition = setLoading;
      if (dadosEmpresa.empresa?.moduloIAfiscal) {
        setLoadingCondition = setLoadingAI;
        setMensagemLoadingAI(MENSAGEMLOADINGEMITIR);
      }
      const notaEmitida = await emitirNfSaida(data?.id, setLoadingCondition);
      if (notaEmitida) {
        if (configuracoes?.visualizarImpressaoEmissao) {
          await imprimeAposEmissao(data.id, false);
        }
        history.push(`/faturamento/nf-saida/${data.id}`);
      }
    } else {
      history.push(`/faturamento/nf-saida/${data.id}`);
    }
  };

  async function imprimeAposEmissao(id, recarregarPagina = true) {
    if (!id) return;
    if (recarregarPagina) {
      history.push(`/faturamento/nf-saida/${id}`);
    }
    setTimeout(() => {
      document.getElementById("danfeButton")?.click();
    }, 2555);
  }

  const imprimeModeloZero = async (data) => {
    if (!configuracoes?.visualizarImpressaoEmissao) {
      initialCollapses();
      voltar();
      return;
    }
    const permissaoDeny = permissoesHelper.temPermisao(
      "nf-saida-enviar-documento-apos-criacao",
    );
    const props = {
      title: "Documento cadastrado com sucesso",
      text: `#${data.numeroDocumento}`,
      icon: "success",
      confirmButtonText: "IMPRIMIR",
      cancelButtonText: permissaoDeny ? "EMAIL" : "FECHAR",
      showCancelButton: true,
      showCloseButton: permissaoDeny,
      closeButtonHtml:
        "<i class='ph-bold ph-x' style='font-size: 21px' aria-hidden='true'></i>",
      dangerMode: true,
    };
    if (permissaoDeny && dadosEmpresa.empresa?.whatsappSimples) {
      props.width = "min(38rem, calc(100vw - 2rem))";
      props.denyButtonText = "WHATSAPP";
      props.showDenyButton = true;
    }
    const confirmacaoAlerta = await notification.confirmacaoGenericos(props);
    if (confirmacaoAlerta.isConfirmed) {
      history.push(`/faturamento/nf-saida/${data.id}`);
      setTimeout(() => {
        if (data.modeloDocumento !== "55") {
          document.getElementById("botaoMenuAction")?.click();
        } else {
          document.getElementById("danfeButton")?.click();
        }
      }, 2600);
    } else if (confirmacaoAlerta?.isDenied) {
      setOpenDialogEnvioWhatsapp(true);
    } else if (confirmacaoAlerta?.dismiss === "cancel" && permissaoDeny) {
      document.getElementById("botaoEmailAction")?.click();
    } else {
      initialCollapses();
      voltar();
    }
  };

  const emitirNfSaidaContigencia = async (setLoadingCondition = setLoading) => {
    setLoadingCondition(true);
    const response = await nfSaidaService.enviarNotaFiscalContigencia(id);
    setLoadingCondition(false);
    return alertaRetornoEmitirNota(response);
  };

  const emitirNfSaida = async (idNfSaida, setLoadingCondition = setLoading) => {
    setLoadingCondition(true);
    const response = await nfSaidaService.emitirNotaFiscal(idNfSaida);
    setLoadingCondition(false);
    setMensagemLoadingAI(null);
    return alertaRetornoEmitirNota(response, idNfSaida);
  };

  const transferirNfSaida = async (nfSaida) => {
    const result = await nfEntradaService.transferencia(nfSaida);
    if (!result.isAxiosError) {
      notification.sucessoGenericos(
        "Documento de Transferência criado com sucesso",
      );
      return true;
    } else {
      const nfTransferenciaCancelar = new NfSaidaCancelamento(
        nfSaida,
        "Cancelada por erro no processo de transferência",
        operacaoFiscal,
      );
      nfSaidaService
        .cancelar(nfSaida?.id, nfTransferenciaCancelar)
        .then((res) => {
          if (!res.isAxiosError) {
            responseErros(result);
          } else {
            responseErros(res);
          }
        });
    }
    return false;
  };

  function alertaRetornoEmitirNota(response, idNfSaida = null) {
    if (!response.isAxiosError) {
      if (response.data?.status === "CONTINGENCIA") {
        notification.alertaGenericos(
          "Nota emitida em CONTINGÊNCIA — SEFAZ indisponível no momento. Imprima a DANFE em contingência e transmita a nota assim que o serviço da SEFAZ for restabelecido.",
        );
      } else {
        notification.sucessoGenericos("Nota Emitida com sucesso");
      }
      return true;
    }
    const res = response.response;
    if (res.status === 500 && res.data?.message) {
      handleDialogErrorDfe(res.data, 500, idNfSaida);
    } else if (res.status === 400 && res.data?.message) {
      handleDialogErrorDfe(res.data, 400, idNfSaida);
    } else {
      notification.alertaGenericos(response.mensagem);
    }
    return false;
  }

  const onClickEmitirNfSaidaEdicao = async () => {
    let setLoadingCondition = setLoading;
    if (dadosEmpresa.empresa?.moduloIAfiscal) {
      setLoadingCondition = setLoadingAI;
      setMensagemLoadingAI(MENSAGEMLOADINGEMITIR);
    }
    const notaEmitida = await emitirNfSaida(id, setLoadingCondition);
    if (notaEmitida) await buscarNfSaida();
  };

  const onClickEmitirNfSaidaContigenciaEdicao = async () => {
    let setLoadingCondition = setLoading;
    if (dadosEmpresa.empresa?.moduloIAfiscal) {
      setLoadingCondition = setLoadingAI;
      setMensagemLoadingAI(MENSAGEMLOADINGEMITIR);
    }
    const notaEmitida = await emitirNfSaidaContigencia(setLoadingCondition);
    if (notaEmitida) await buscarNfSaida();
  };

  const onClickCriarContingenciaNfSaidaPendente = async () => {
    const idNf = errosDfe?.idNfSaida || id;
    if (idNf) {
      const notaEmitidaContingencia = await emitirNfSaidaPendenteContingencia(
        idNf,
      );
      if (notaEmitidaContingencia) {
        if (id) await buscarNfSaida();
        await imprimeAposEmissao(idNf);
      }
    }
  };

  const emitirNfSaidaPendenteContingencia = async (idNfSaida) => {
    setLoading(true);
    const response = await nfSaidaService.emitirNotaFiscalPendenciaContingencia(
      idNfSaida,
    );
    setLoading(false);
    return alertaRetornoEmitirPendenteContingenciaNota(response);
  };

  function alertaRetornoEmitirPendenteContingenciaNota(response) {
    if (!response.isAxiosError) {
      notification.sucessoGenericos("Nota emitida em contingência com sucesso");
      return true;
    }
    notification.alertaGenericos(response.mensagem);
    return false;
  }

  const onClickBaixarXml = async () => {
    setLoading(true);
    const result = await nfSaidaService.getArquivoXml(id);
    if (!result.isAxiosError) {
      const blob = new Blob([result.data], { type: "text/xml" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `${nfSaida.chaveAcesso}.xml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  async function onClickConsultarStatus() {
    setLoading(true);
    const result = await nfSaidaService.consultarStatusNotaFiscal(id);
    setLoading(false);
    if (!result.isAxiosError) {
      buscaDadosIniciais();
      notification.alertaGenericos("Status atualizado para Enviada");
    } else {
      alertaRetornoConsultarStatus(result);
    }
  }

  function alertaRetornoConsultarStatus(result) {
    const response = result.response;
    if (response.status == 500) {
      notification.alertaGenericos(response.data.message);
    }
  }

  function tituloLayout() {
    if (documentoTransferencia) {
      return "Documento de Transferência";
    }

    if (!isNaN(Number(id))) {
      return "Visualizar Nf-Saida";
    }

    return "Cadastrar Nf-Saida";
  }

  const operacaoFiscalBloqueada = Boolean(
    id || (documentoImportado && nfSaida?.operacaoFiscalId),
  );

  return (
    <AddLayout
      id={id}
      showUpdate={
        (!id && nfSaida?.status === "PENDENTE") ||
        permissoesHelper.temPermisao("nf-saida-editar")
      }
      title={tituloLayout()}
      onClickSalvar={validarNfSaida}
      loading={loading}
      codigo={
        id && nfSaida?.numeroDocumento
          ? `Nº Documento ${nfSaida?.numeroDocumento}`
          : ""
      }
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      ButtonMenu={
        <ButtonMenu
          id={nfSaida?.id || id}
          nfSaida={{
            ...nfSaida,
            ...nfSaidaEntity,
            id: nfSaida?.id || id,
            empresa: {
              ...dadosEmpresa.empresa,
              email: dadosEmpresa.empresa?.email,
              cnpjCpf: dadosEmpresa.empresa?.cnpjCpf,
              uf: dadosEmpresa.empresa?.enderecoUF,
              nome:
                dadosEmpresa.empresa?.fantasia ??
                dadosEmpresa.empresa?.razaoSocial,
              telefone:
                dadosEmpresa.empresa?.telefone ?? dadosEmpresa.empresa?.celular,
              emiteNfe: dadosEmpresa.empresa?.emiteNfe,
              emiteNfce: dadosEmpresa.empresa?.emiteNfce,
            },
            vendedor: value.autoComplete(vendedorList, nfSaida?.vendedorId),
            cliente: clienteSelecionado,
            enderecoCliente: enderecoAleterado || enderecoCliente,
            estadoCliente: enderecoCliente?.estado,
            pagamentos: nfSaidaPagamentos,
            meioPagamentoList,
          }}
          operacaoFiscal={operacaoFiscal}
          onClickCancelarNfSaida={onClickCancelarNfSaida}
          onClickEmitirNfSaida={onClickEmitirNfSaidaEdicao}
          onClickEmitirNfSaidaContigenciaEdicao={
            onClickEmitirNfSaidaContigenciaEdicao
          }
          onClickCriarContingenciaNfSaidaPendente={
            onClickCriarContingenciaNfSaidaPendente
          }
          onClickValidarNfSaida={onClickValidarNfSaida}
          onClickCartaCorrecao={onClickCartaCorrecao}
          onClickConsultarStatus={onClickConsultarStatus}
          onClickBaixarXml={onClickBaixarXml}
          permissaoCancelar={permissoesHelper.temPermisao("nf-saida-cancelar")}
          openDialogEnvioWhatsapp={openDialogEnvioWhatsapp}
          setOpenDialogEnvioWhatsapp={setOpenDialogEnvioWhatsapp}
          envioMensagemBoleto={envioMensagemBoleto}
          listaIdImpressao={listaIdImpressao}
          emitirAposCadastro={emitirAposCadastro}
          setLoading={setLoading}
        />
      }
      actions={
        (!id && !documentoImportado) || nfSaidaEntity.operacaoEntrada ? (
          <Tooltip title="Copiar Nf-Saida" arrow placement="left">
            <IconButton onClick={() => onClickOpenDialogCopiarNfSaida()}>
              <i
                className="ph-fill ph-copy-simple"
                style={{ fontSize: 18 }}
              ></i>
            </IconButton>
          </Tooltip>
        ) : (
          <></>
        )
      }
      actionsTotalizadores={
        <ResumoTotal
          nfSaidaId={id}
          nfSaida={nfSaida}
          nfSaidaEntity={nfSaidaEntity}
          setNfSaida={setNfSaida}
          totalItensLista={totalItensLista}
          nfSaidaProdutos={nfSaidaProdutos}
          setNfSaidaProdutos={setNfSaidaProdutos}
          abaValue={abaValue}
          setNfSaidaPagamentos={setNfSaidaPagamentos}
          permissaoEditarDesconto={permissoesHelper.temPermisao(
            "nf-saida-editar-desconto",
          )}
        />
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Autocomplete
            required
            id="operacaoFiscalId"
            name="operacaoFiscalId"
            options={operacaoFiscalList}
            noOptionsText="Sem opções"
            autoHighlight
            disableClearable
            getOptionLabel={(option) =>
              option.descricao ? option.descricao : ""
            }
            disabled={operacaoFiscalBloqueada}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Operação Fiscal"
                variant={nfSaida.status === "CANCELADA" ? "filled" : "outlined"}
                disabled={operacaoFiscalBloqueada}
                error={inputErros.get("operacaoFiscalId")}
                required
              />
            )}
            onChange={(_, newValue) => {
              onChangeAutocompleteOperacaoFiscal(newValue);
            }}
            value={
              operacaoFiscal
                ? operacaoFiscal
                : value.autoComplete(
                    operacaoFiscalList,
                    nfSaida.operacaoFiscalId,
                  )
            }
          />
        </Grid>
        <Grid item xs={1.2}>
          <TextField
            id="serieDocumento"
            name="serieDocumento"
            label="Série"
            variant="outlined"
            disabled
            value={nfSaida.serieDocumento ?? ""}
            fullWidth
          />
        </Grid>
        <Grid item xs={1.2}>
          <TextField
            id="numeroDocumento"
            name="numeroDocumento"
            type="number"
            label="Nº Documento"
            variant="outlined"
            disabled
            value={nfSaida.numeroDocumento ?? ""}
            InputProps={{ inputProps: { min: 0 } }}
            fullWidth
          />
        </Grid>
        <Grid item xs={1.2}>
          <TextField
            id="modeloDocumento"
            name="modeloDocumento"
            label="Modelo"
            variant="outlined"
            disabled
            value={nfSaida.modeloDocumento ?? ""}
            fullWidth
          />
        </Grid>
        <Grid item xs={1.8}>
          <DatePicker
            id="dataEmissao"
            name="dataEmissao"
            label="Data Emissão"
            format="dd/MM/yyyy"
            variant="outlined"
            disabled={id || dataEmissaoBloqueada(operacaoFiscal)}
            required
            value={nfSaida?.dataEmissao ? nfSaida.dataEmissao : null}
            onChange={(date) => {
              setInputErro([]);
              handleDateChange("dataEmissao", date);
            }}
            error={inputErros.get("dataEmissao")}
          />
        </Grid>
        <Grid item xs={1.8}>
          <DatePicker
            id="dataSaida"
            name="dataSaida"
            label="Data Saida"
            format="dd/MM/yyyy"
            variant="outlined"
            disabled={id}
            required
            minDate={
              modeloDocumentoFiscal(operacaoFiscal) && nfSaida?.dataEmissao
                ? new Date(nfSaida.dataEmissao)
                : undefined
            }
            value={nfSaida?.dataSaida ? nfSaida.dataSaida : null}
            onChange={(date) => {
              setInputErro([]);
              handleDateChange("dataSaida", date);
            }}
            error={inputErros.get("dataSaida")}
          />
        </Grid>
        <Grid item xs={1.8}>
          <DatePicker
            id="dataPrevisaoEntrega"
            name="dataPrevisaoEntrega"
            label="Previsão de Entrega"
            format="dd/MM/yyyy"
            variant="outlined"
            disabled={id || nfSaida?.modeloDocumento !== "55"}
            value={
              nfSaida?.dataPrevisaoEntrega ? nfSaida.dataPrevisaoEntrega : null
            }
            onChange={(date) => {
              setInputErro([]);
              handleDateChange("dataPrevisaoEntrega", date);
            }}
            error={inputErros.get("dataPrevisaoEntrega")}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} className="mt-2">
        <Grid item xs={6} className="d-flex align-items-start">
          {!documentoTransferencia ? (
            <>
              <Grid
                item
                xs={!id && nfSaida?.clienteId && nfsSaida.length ? 15 : 40}
              >
                <Grid item xs={12}>
                  <Autocomplete
                    id="clienteId"
                    name="clienteId"
                    disabled={
                      (id && nfSaida?.status !== "PENDENTE") || abaValue !== 0
                    }
                    options={clienteList}
                    autoHighlight
                    getOptionLabel={(option) => {
                      let codigoPessoa = option?.codigo
                        ? `${option.codigo} - `
                        : "";
                      let descricaoPessoa =
                        codigoPessoa + `${option.nomeRazaoSocial}`;
                      return option ? descricaoPessoa : "";
                    }}
                    loading={loadingAutoComplete}
                    loadingText="Carregando"
                    noOptionsText={
                      document.getElementById("clienteId")?.value.length >= 1 &&
                      !id ? (
                        <Grid container spacing={1}>
                          <Grid item xs={12} fullWidth>
                            Nenhum cliente encontrado
                          </Grid>
                        </Grid>
                      ) : (
                        "Digite e pressione Enter"
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          !nfSaidaEntity?.documentoDevolucaoFornecedor
                            ? "Cliente"
                            : "Fornecedor"
                        }
                        error={inputErros.get("clienteId")}
                        required={operacaoFiscal?.modeloDocumento === "55"}
                        variant={"outlined"}
                        onKeyDown={(e) =>
                          onSearchChangePessoas(
                            e,
                            inputCliente,
                            !nfSaidaEntity?.documentoDevolucaoFornecedor
                              ? 1
                              : 2,
                          )
                        }
                        inputRef={inputCliente}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {operacaoFiscal?.modeloDocumento === "65" &&
                                !id && (
                                  <InputAdornment position="end">
                                    <Tooltip
                                      title="Identificar Cliente"
                                      arrow
                                      placement="bottom"
                                    >
                                      <IconButton
                                        disabled={id}
                                        onClick={() =>
                                          setIdentificarClienteDialogOpen(true)
                                        }
                                      >
                                        <i
                                          className="ph ph-user"
                                          style={{ fontSize: 24 }}
                                        ></i>
                                      </IconButton>
                                    </Tooltip>
                                  </InputAdornment>
                                )}
                              <React.Fragment>
                                {loadingAutoComplete ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            </>
                          ),
                        }}
                      />
                    )}
                    onChange={(_, newValue) =>
                      onChangeAutocompleteCliente(newValue)
                    }
                    value={clienteSelecionado}
                  />
                </Grid>
                {!id && clienteSelecionado?.limiteCreditoDisponivel ? (
                  <Grid item xs={12} className="mt-2">
                    <Chip
                      label={`Crédito Disponível: ${formatPrice(
                        clienteSelecionado?.limiteCreditoDisponivel,
                      )}`}
                      className="mb-2"
                      color={"success"}
                      sx={{
                        borderRadius: "4px",
                        height: "23px",
                        "& .MuiChip-label": {
                          fontWeight: "600",
                          fontSize: "11px",
                          letterSpacing: ".2px",
                        },
                      }}
                    />
                  </Grid>
                ) : null}
              </Grid>
              <Grid
                item
                xs={2}
                sx={{ ml: 2, mt: 1 }}
                className={`d-flex align-items-center justify-content-${
                  !id && nfSaida?.clienteId ? "between" : "end"
                }`}
              >
                <Tooltip title="Cadastrar Cliente" arrow placement="bottom">
                  <Button
                    id="buttonAdicionarCliente"
                    variant="contained"
                    disabled={id || !nfSaida?.operacaoFiscalId}
                    size="small"
                    sx={{
                      height: "35px",
                      borderRadius: "20%",
                      minWidth: "15px",
                      boxShadow: "none",
                    }}
                    onClick={() => setIsCadastroPessoaDialogOpen(true)}
                  >
                    <i
                      className="ph-bold ph-plus"
                      style={{ color: "#fff", fontSize: 15 }}
                    ></i>
                  </Button>
                </Tooltip>
                {!id && nfSaida?.clienteId && nfsSaida?.length ? (
                  <>
                    {loadingHistorico ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      <Tooltip
                        title="Visualizar Histórico Cliente"
                        arrow
                        placement="bottom"
                      >
                        <Button
                          id="buttonAdicionarCliente"
                          variant="contained"
                          disabled={
                            !nfSaida?.operacaoFiscalId || !nfSaida?.clienteId
                          }
                          size="small"
                          sx={{
                            height: "35px",
                            borderRadius: "20%",
                            minWidth: "15px",
                            boxShadow: "none",
                          }}
                          onClick={() => {
                            setOpenHistoricoClienteDialog(true);
                          }}
                        >
                          <i
                            className="ph-fill ph-shopping-cart"
                            style={{ fontSize: 15, color: "white" }}
                          ></i>
                        </Button>
                      </Tooltip>
                    )}
                  </>
                ) : null}
              </Grid>
            </>
          ) : (
            <>
              <Autocomplete
                id="empresaDestinoId"
                name="empresaDestinoId"
                options={empresas}
                noOptionsText="Sem opções"
                autoHighlight
                getOptionLabel={(option) =>
                  option?.cnpjCpf
                    ? `${formatCnpj(option.cnpjCpf)} - ${option.fantasia}`
                    : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Empresa Destino"
                    variant="outlined"
                    error={inputErros.get("empresaDestinoId")}
                  />
                )}
                onChange={(e, value) =>
                  onChangeAutocompleteEmpresaDestino(value)
                }
                value={value.autoComplete(empresas, nfSaida?.empresaDestinoId)}
              />
            </>
          )}
        </Grid>
        <Grid item xs={3.5}>
          <Autocomplete
            id="vendedorId"
            name="vendedorId"
            disabled={
              id ||
              !nfSaida?.operacaoFiscalId ||
              colaboradorVendedor ||
              nfSaidaEntity?.documentoDevolucaoCliente
            }
            options={vendedorList}
            autoHighlight
            getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Vendedor"
                variant={"outlined"}
                required={vendedorObrigatorio}
                error={inputErros.get("vendedorId")}
              />
            )}
            onChange={(_, newValue) => {
              setInputErro([]);
              onChangeAutocomplete("vendedorId", newValue);
            }}
            value={value.autoComplete(vendedorList, nfSaida?.vendedorId)}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="status"
            name="status"
            label="Status"
            variant="outlined"
            disabled
            value={nfSaida.status ?? ""}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {verificarStatus(nfSaida.status)}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={0.5}>
          <IconButton
            variant="contained"
            size="small"
            className="mt-2"
            onClick={() =>
              setTiposTotalizadoresColumnView(!tiposTotalizadoresColumnView)
            }
          >
            <i
              className="ph-bold ph-caret-down"
              style={{
                color: "#494c62",
                rotate: tiposTotalizadoresColumnView ? "180deg" : "0deg",
              }}
            ></i>
          </IconButton>
        </Grid>
      </Grid>
      {tiposTotalizadoresColumnView && (
        <Grid
          container
          spacing={2}
          className={!clienteSelecionado?.limiteCreditoDisponivel && "mt-2"}
        >
          <Grid item xs={6}></Grid>
          <Grid item xs={2} className="d-flex justify-content-end">
            <FormControlLabel
              label="Desconto por Item"
              labelPlacement="end"
              control={
                <Checkbox
                  name="descontoItem"
                  checked={nfSaida?.descontoItem ?? false}
                  onChange={(e) =>
                    handleChangeSwitch(e.target.name, e.target.checked)
                  }
                  color="primary"
                />
              }
            />
          </Grid>
          <Grid item xs={2} className="d-flex justify-content-end">
            <FormControlLabel
              label="Frete por Item"
              labelPlacement="end"
              control={
                <Checkbox
                  name="freteItem"
                  checked={nfSaida?.freteItem ?? false}
                  onChange={(e) =>
                    handleChangeSwitch(e.target.name, e.target.checked)
                  }
                  color="primary"
                />
              }
            />
          </Grid>
          <Grid item xs={2} className="d-flex justify-content-end">
            <FormControlLabel
              label="Despesa por Item"
              labelPlacement="end"
              control={
                <Checkbox
                  name="despesasItem"
                  checked={nfSaida?.despesasItem ?? false}
                  onChange={(e) =>
                    handleChangeSwitch(e.target.name, e.target.checked)
                  }
                  color="primary"
                />
              }
            />
          </Grid>
        </Grid>
      )}
      {(nfSaida.status === "ENVIADA" || nfSaida.status === "CANCELADA") && (
        <Grid container spacing={2} className="mt-2">
          <Grid item xs={6}>
            <TextField
              id="chaveAcesso"
              name="chaveAcesso"
              label="Chave de Acesso"
              variant="outlined"
              disabled
              value={nfSaida.chaveAcesso ?? ""}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="numeroProtoc"
              name="numeroProtoc"
              label="Número Protocolo"
              variant="outlined"
              disabled
              value={nfSaida.numeroProtoc ?? ""}
              fullWidth
            />
          </Grid>
        </Grid>
      )}
      <hr className="mt-4 mb-2" />
      <Paper>
        <Tabs
          value={abaValue}
          onChange={async (e, value) => {
            e.persist();
            const pagamentosIndex = operacaoFiscal?.movimentacaoFinanceira
              ? 1
              : null;
            if (
              operacaoFiscal?.movimentacaoFinanceira &&
              value === pagamentosIndex
            ) {
              await alertaNotasCredito();
            }
            setAbaValue(value);
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            label="ITENS DA NOTA"
            {...tabProps(0)}
            disabled={
              !id &&
              configuracoes?.obrigatoriedadeMeioPagamento &&
              !condicaoSelecionada &&
              operacaoFiscal?.movimentacaoFinanceira &&
              !nfSaidaProdutos?.length
            }
          />
          {operacaoFiscal?.movimentacaoFinanceira && (
            <Tab label="PAGAMENTOS" {...tabProps(1)} />
          )}
          <Tab
            disabled={!clienteSelecionado && !empresaSelecionada}
            label="DADOS DO CLIENTE"
            {...tabProps(operacaoFiscal?.movimentacaoFinanceira ? 2 : 1)}
          />
          <Tab
            label="TRIBUTOS"
            {...tabProps(operacaoFiscal?.movimentacaoFinanceira ? 3 : 2)}
          />
          <Tab
            label="TRANSPORTE"
            {...tabProps(operacaoFiscal?.movimentacaoFinanceira ? 4 : 3)}
          />
          <Tab
            label="INFORMAÇÕES ADICIONAIS"
            {...tabProps(operacaoFiscal?.movimentacaoFinanceira ? 5 : 4)}
          />
        </Tabs>
      </Paper>
      <CardContent>
        <TabPanel value={abaValue} index={0}>
          {abaValue === 0 ? (
            <NfSaidaItens
              nfSaidaId={id}
              nfSaida={nfSaida}
              setNfSaida={setNfSaida}
              nfSaidaEntity={nfSaidaEntity}
              nfSaidaProdutos={nfSaidaProdutos}
              item={item}
              setItem={setItem}
              tabelas={tabelas}
              listaProdutosSimilares={listaProdutosSimilares}
              setListaProdutosSimilares={setListaProdutosSimilares}
              setNfSaidaProdutos={setNfSaidaProdutos}
              setNfSaidaPagamentos={setNfSaidaPagamentos}
              setLoading={setLoading}
              permitirVendaEstoqueNegativo={configuracoes?.vendaEstoqueNegativo}
              situacaoIpiList={situacaoIpiList}
              origensMercadoriasList={origensMercadoriasList}
              operacaoFiscal={operacaoFiscal}
              unidadeList={unidadeList}
              setUnidadeList={setUnidadeList}
              gruposTributacaoList={gruposTributacaoList}
              setGruposTributacaoList={setGruposTributacaoList}
              csoSimplesList={csoSimplesList}
              setCsoSimplesList={setCsoSimplesList}
              situacaoIbsList={situacaoIbsList}
              setSituacaoIbsList={setSituacaoIbsList}
              classificacaoIbsList={classificacaoIbsList}
              setClassificacaoIbsList={setClassificacaoIbsList}
              enquadramentoLegalList={enquadramentoLegalList}
              setEnquadramentoLegalList={setEnquadramentoLegalList}
              permissaoEditarPrecoVenda={permissoesHelper.temPermisao(
                "nf-saida-preco-venda",
              )}
              meioPagamentoSelecionado={meioPagamentoSelecionado}
              acrescimoPagamento={acrescimoPagamento}
              produto={produto}
              setProduto={setProduto}
              clienteSelecionado={clienteSelecionado}
              buscarNotasCredito={buscarNotasCredito}
              transferencia={transferencia}
              tabelasTodosProdutos={tabelasTodosProdutos}
              setLoadingAI={setLoadingAI}
              enderecosEstoqueList={enderecosEstoqueList}
            />
          ) : null}
        </TabPanel>
        {operacaoFiscal?.movimentacaoFinanceira && (
          <TabPanel value={abaValue} index={1}>
            {abaValue === 1 ? (
              <NfSaidaPagamentos
                nfSaidaId={id}
                nfSaida={nfSaida}
                setNfSaida={setNfSaida}
                nfSaidaEntity={nfSaidaEntity}
                nfSaidaPagamentos={nfSaidaPagamentos}
                setNfSaidaPagamentos={setNfSaidaPagamentos}
                meioPagamentoList={meioPagamentoList}
                onChangeAutocomplete={onChangeAutocomplete}
                handleInputChange={handleInputChange}
                meioPagamentoSelecionado={meioPagamentoSelecionado}
                setMeioPagamentoSelecionado={setMeioPagamentoSelecionado}
                condicaoSelecionada={condicaoSelecionada}
                setCondicaoSelecionada={setCondicaoSelecionada}
                meiosPagamentoCliente={meiosPagamentoCliente}
                gerarPagamentos={gerarPagamentos}
                setGerarPagamentos={setGerarPagamentos}
                condicaoPagParcelaList={condicaoPagParcelaList}
                setCondicaoPagParcelaList={setCondicaoPagParcelaList}
                listaNotasCredito={listaNotasCredito}
                setListaNotasCredito={setListaNotasCredito}
                setOpenNotasCreditoDialog={setOpenNotasCreditoDialog}
                openNotasCreditoDialog={openNotasCreditoDialog}
                notasCredito={notasCredito}
                setNotasCredito={setNotasCredito}
                meioPagamentoCredito={meioPagamentoCredito}
                buscarNotasCredito={buscarNotasCredito}
                setAbaValue={setAbaValue}
                obrigatoriedadeMeioPagamento={
                  configuracoes?.obrigatoriedadeMeioPagamento
                }
                nfSaidaProdutos={nfSaidaProdutos}
                setNfSaidaProdutos={setNfSaidaProdutos}
                setAcrescimoPagamento={setAcrescimoPagamento}
                item={item}
                setItem={setItem}
                produto={produto}
                clienteSelecionado={clienteSelecionado}
              />
            ) : null}
          </TabPanel>
        )}
        <TabPanel
          value={abaValue}
          index={operacaoFiscal?.movimentacaoFinanceira ? 2 : 1}
        >
          {clienteSelecionado ||
          abaValue === (operacaoFiscal?.movimentacaoFinanceira ? 2 : 1) ? (
            <NfSaidaDadosClientes
              nfSaidaId={id}
              nfSaida={nfSaida}
              enderecoAleterado={enderecoAleterado}
              setEnderecoAleterado={setEnderecoAleterado}
              enderecoCliente={enderecoCliente}
              enderecoClienteDataGrid={enderecoClienteDataGrid}
              clienteSelecionado={clienteSelecionado}
              cidadeId={cidadeId}
              setCidadeId={setCidadeId}
              endereco={endereco}
              setEndereco={setEndereco}
              salvarEndereco={salvarEndereco}
              clienteSemCadastro={clienteSemCadastro}
              inputErros={inputErros}
              nfSaidaEntity={nfSaidaEntity}
              empresaSelecionada={empresaSelecionada}
            />
          ) : null}
        </TabPanel>
        <TabPanel
          value={abaValue}
          index={operacaoFiscal?.movimentacaoFinanceira ? 3 : 2}
        >
          {abaValue === (operacaoFiscal?.movimentacaoFinanceira ? 3 : 2) ? (
            <NfSaidaTributos
              nfSaida={nfSaida}
              setNfSaida={setNfSaida}
              nfSaidaEntity={nfSaidaEntity}
            />
          ) : null}
        </TabPanel>
        <TabPanel
          value={abaValue}
          index={operacaoFiscal?.movimentacaoFinanceira ? 4 : 3}
        >
          <NfSaidaTransporte
            id={id}
            nfSaida={nfSaida}
            nfSaidaEntity={nfSaidaEntity}
            setNfSaida={setNfSaida}
            transportadoraList={transportadoraList}
            transportadoraSelecionada={transportadoraSelecionada}
            setTransportadoraSelecionada={setTransportadoraSelecionada}
            inputErros={inputErros}
            setInputErro={setInputErro}
            handleInputChange={handleInputChange}
            onChangeAutocomplete={onChangeAutocomplete}
            onSearchChangePessoas={onSearchChangePessoas}
            buscarDadosTransportadora={buscarDadosTransportadora}
          />
        </TabPanel>
        <TabPanel
          value={abaValue}
          index={operacaoFiscal?.movimentacaoFinanceira ? 5 : 4}
        >
          {abaValue === (operacaoFiscal?.movimentacaoFinanceira ? 5 : 4) ? (
            <NfSaidaInformacoes
              nfSaidaId={id}
              nfSaida={nfSaida}
              nfSaidaEntity={nfSaidaEntity}
              setNfSaida={setNfSaida}
              intermediadorSelecionado={intermediadorSelecionado}
              setIntermediadorSelecionado={setIntermediadorSelecionado}
              handleInputChange={handleInputChange}
              buscarNfSaidaReferencia={buscarNfSaidaReferencia}
              documentosReferenciados={documentosReferenciados}
              setDocumentosReferenciados={setDocumentosReferenciados}
              nfSaidaListReferencia={nfSaidaListReferencia}
              setNfSaidaListReferencia={setNfSaidaListReferencia}
            />
          ) : null}
        </TabPanel>
      </CardContent>
      <FullscreenDialog
        open={isCadastroPessoaDialogOpen}
        handleClose={handleCloseCadastroCliente}
        content={
          <AddPessoas
            match={{ params: { id: null } }}
            isFullscreenDialog
            onChangeCliente={onChangeAutocompleteCliente}
            handleCloseFullscreenDialog={handleCloseCadastroCliente}
          />
        }
      />
      <HistorioClienteDialog
        open={openHistoricoClienteDialog}
        setOpen={setOpenHistoricoClienteDialog}
        clienteId={nfSaida?.clienteId}
        nfsSaida={nfsSaida}
        setNfsSaida={setNfsSaida}
        totalItems={totalItems}
        setTotalItems={setTotalItems}
      />
      <CancelamentoDialog
        open={openCancelamentoDialog}
        setOpen={setOpenCancelamentoDialog}
        setLoading={setLoading}
        id={id}
        operacaoFiscal={operacaoFiscal}
        nfSaida={nfSaida}
      />
      <ErrosDfeDialog
        open={errosDfeDialogOpen}
        setOpen={setErrosDfeDialogOpen}
        errosDfe={errosDfe}
        handleInputChange={handleInputChange}
        onClickCriarContingenciaNfSaidaPendente={
          onClickCriarContingenciaNfSaidaPendente
        }
        onClickEmitirNfSaidaEdicao={onClickEmitirNfSaidaEdicao}
        emitirNfSaida={emitirNfSaida}
        nfSaida={nfSaida}
        nfSaidaId={id}
        nfSaidaEntity={nfSaidaEntity}
        setNfSaidaProdutos={setNfSaidaProdutos}
        setLoadingAI={setLoadingAI}
        setMensagemLoadingAI={setMensagemLoadingAI}
        MENSAGEMLOADINGEMITIR={MENSAGEMLOADINGEMITIR}
      />
      <IdentificarClienteDialog
        open={identificarClienteDialogOpen}
        setOpen={setIdentificarClienteDialogOpen}
        setClienteSelecionado={setClienteSelecionado}
        nfSaidaEntity={nfSaidaEntity}
        setNfSaida={setNfSaida}
        setClienteSemCadastro={setClienteSemCadastro}
      />
      <CartaCorrecaoDialog
        openCartaCorrecaoDialog={openCartaCorrecaoDialog}
        setOpenCartaCorrecaoDialog={setOpenCartaCorrecaoDialog}
        id={id}
        setLoading={setLoading}
        nfSaida={nfSaida}
        nfSaidaEntity={nfSaidaEntity}
        setNfSaida={setNfSaida}
        clienteSelecionado={clienteSelecionado}
        enderecoCliente={enderecoCliente}
      />
      <CopiarNfSaidaDialog
        open={openCopiarNfSaidaDialog}
        setOpen={setOpenCopiarNfSaidaDialog}
        nfSaidaEntity={nfSaidaEntity}
        setNfSaida={setNfSaida}
        setNfSaidaProdutos={setNfSaidaProdutos}
        setCliente={onChangeAutocompleteCliente}
      />
      <EnderecoClienteEstabelecimentoDialog
        open={openEnderecoClienteForaEstabelecimentoDialog}
        setOpen={setOpenEnderecoClienteForaEstabelecimentoDialog}
        nfSaidaEntity={nfSaidaEntity}
        listaEstados={listaEstados}
      />
      <PermissionDialog dialog={dialogLimiteCreditoUltrapassado} />
      <EmissaoBoletoDialog
        open={openEmissaoBoletoDialog}
        setOpen={setOpenEmissaoBoletoDialog}
        boletos={boletos}
        setBoletos={setBoletos}
        dadosNfSaida={nfSaida}
        emitirBoletos={emitirBoletos}
      />
      <SelecionarInscricaoEstadualDialog
        dialogInscricaoEstadual={dialogInscricaoEstadual}
        inscricoesEstaduais={inscricoesEstaduais}
        inscricaoSelecionada={inscricaoSelecionada}
        setInscricaoSelecionada={setInscricaoSelecionada}
        enderecos={enderecoClienteDataGrid}
        confirmarInscricaoEstadual={confirmarInscricaoEstadual}
      />
      <LoadingAi loading={loadingAI} mensagens={mensagemLoadingAI} />
    </AddLayout>
  );
};

export default AddNfSaida;
